import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-update-worker',
  templateUrl: './update-worker.component.html',
  styleUrl: './update-worker.component.css',
  standalone: true,
  imports: [
    
  ]
})
export class UpdateWorkerComponent {
  @Output() update: EventEmitter<string> = new EventEmitter();
}
